module.exports = __webpack_public_path__ + "static/media/check_unchecked.6712ee26.svg";